export const links =
  "bg-white bg-opacity-[.7] backdrop-blur-sm backdrop-filter px-4 py-2 font-semibold transition duration-300 hidden md:block uppercase hover:bg-naturegreen hover:text-white";

export const activelinks =
  "bg-naturegreen text-white hover:bg-naturegreen bg-opacity-[.7] backdrop-blur-sm backdrop-filter hidden md:block px-4 py-2 font-semibold uppercase";

export const sidenavLink =
  "text-[24px] font-black text-gray-500 transition duration-300 ease-in-out uppercase";

export const activeSidenavLink =
  "text-[24px] font-black text-naturegreen transition duration-300 ease-in-out uppercase hover:scale-105 hover:text-naturegreen";

export const footerLinks =
  "text-[12px] font-semibold text-gray-500 transition duration-300 ease-in-out hover:scale-105 hover:text-darkgreen";

export const activeFooterLinks =
  "text-[12px] font-semibold text-darkgreen transition duration-300 ease-in-out hover:scale-105 hover:text-darkgreen";

export const navbtn =
  "hidden md:flex gap-2 items-center border border-2 border-cus border-leaf px-2 py-1 font-semibold transition duration-300 ease-in-out hover:scale-105";

export const btn =
  "flex items-center justify-center gap-2 px-[14px] py-[12px] text-xs rounded-md transition duration-300 ease-in-out hover:scale-105";
